import React from 'react';
import clsx from 'clsx';
import CloseIcon from '~/icons/close.svg';
import { SearchInput } from '~/shared/components/form';
import { useTranslation } from '~/shared/utils/translation';
import styles from './StoreSearchInput.module.scss';

type Props = {
    value: string;
    setValue: (value: string) => void;
    disabled?: boolean;
    inputRef?: React.Ref<HTMLInputElement>;
    className?: string;
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
};

export const StoreSearchInput = ({
    value,
    setValue,
    disabled,
    inputRef,
    className,
    onKeyDown,
}: Props) => {
    const { translate } = useTranslation();

    const handleResetSearch = () => {
        setValue('');

        if (inputRef && typeof inputRef !== 'function') {
            inputRef.current?.focus();
        }
    };

    return (
        <div className={clsx(styles.storeSearchInput, className)}>
            <SearchInput
                inputRef={inputRef}
                disabled={disabled}
                name="query"
                placeholder={translate('findStore.searchZipCode')}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={onKeyDown}
            />
            {value && (
                <button
                    aria-label={translate('header.closeSearch')}
                    className={styles.clearButton}
                    disabled={disabled}
                    type="button"
                    onClick={handleResetSearch}
                >
                    <CloseIcon />
                </button>
            )}
        </div>
    );
};
